import { useSyncExternalStore } from 'react';

interface DeveloperFeatures {
  donorNavigation: boolean;
  search: boolean;
}

const hidden: Readonly<DeveloperFeatures> = { donorNavigation: false, search: false };
const visible: Readonly<DeveloperFeatures> = { donorNavigation: true, search: true };
const initialFeatures =
  import.meta.env.DEV || import.meta.env.MODE === 'test' || import.meta.env.MODE === 'staging'
    ? visible
    : hidden;
let features = initialFeatures;
const listeners = new Set<() => void>();

export function enableDeveloperFeatures(): void {
  if (features === visible) return;
  features = visible;
  listeners.forEach((listener) => listener());
}

// Presentation controls only. Routes, API authorization, and payment protection stay intact.
// Local, test and staging start with every entry point visible. Production activation
// stays in memory and resets on reload; it never changes API authorization.

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDeveloperFeatures(): Readonly<DeveloperFeatures> {
  return useSyncExternalStore(
    subscribe,
    () => features,
    () => initialFeatures,
  );
}
